<template>
  <!-- 退单规范评价组件 -->
  <div>
    <template>
      <el-button v-if="returnAdminName"
                 v-permission="288"
                 type="primary"
                 size="mini"
                 @click="showOrderReturnEvalDialog()">
        退单规范评价
      </el-button>
    </template>

    <el-dialog title="退单规范评价"
               :modal-append-to-body="true"
               :append-to-body="true"
               :visible.sync="dialogReturnEvalVisible"
               width="50%">
      <el-form :model="orderReturnEvalForm"
               label-width="150px"
               label-position="right">
        <div class="re-el-form__flex">
          <el-form-item label="评价人：">
            <span>{{ reviewer }}</span>
          </el-form-item>
          <el-form-item label="退单人：">
            <span>{{ returnAdminName }}</span>
          </el-form-item>
          <el-form-item label="评价时间："
                        v-if="isView">
            <span>{{ reviewAt }}</span>
          </el-form-item>
          <el-form-item label="审核流程是否规范："
                        prop="is_standard">
            <template v-if="isView">
              <span>{{ orderReturnEvalForm.is_standard > 0 ? '规范' : '不规范' }}</span>
            </template>
            <template v-else>
              <el-radio-group v-model="orderReturnEvalForm.is_standard"
                              @change="orderReturnEvalForm.non_standard_reason = []">
                <el-radio :label="1"
                          :disabled="isView">规范
                </el-radio>
                <el-radio :label="0"
                          :disabled="isView">不规范
                </el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="不规范原因："
                        prop="non_standard_reason">
            <div class="question-labels"
                 v-if="isView">
              <div v-for="(question, index) in orderReturnEvalForm.non_standard_reason"
                   :key="index"
                   class="question-label-item">
                {{ question }}
              </div>
            </div>
            <template v-else>
              <el-select class="width-max"
                         v-model="orderReturnEvalForm.non_standard_reason"
                         :disabled="orderReturnEvalForm.is_standard > 0"
                         multiple>
                <el-option v-for="item in nonStandardReasonsList"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </template>
          </el-form-item>
        </div>
        <div>
          <span style="color: #999;font-size: 13px;">审核规范说明：针对实习生审单规范评分，其项目组长或者客服人员进行反馈打分。系统会根据反馈情况统计得分</span>
        </div>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   v-if="isView"
                   @click="closeDialog()">关闭
        </el-button>
        <el-button type="primary"
                   v-else
                   @click="handleOrderReturnEvalSubmit">确定
        </el-button>
        <el-button @click="closeDialog()">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import orderReviewValidate from '@views/order-review/mixins/order-review-validate.mixin.js'

export default {
  components: {},
  mixins: [orderReviewValidate],
  inject: ['page'],
  props: {
    id: [Number, String],
  },
  data () {
    return {
      dialogReturnEvalVisible: false,
      orderReturnEvalForm: {
        orderId: null,
        is_standard: 1,
        non_standard_reason: [],
        return_adminname: null
      },
      isView: false,
      reviewer: '',
      reviewAt: '',
      nonStandardReasonsList: [
        '退单原因错误',
        '审核备注不清楚',
        '审核图片没标注',
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user,
      orderDetail: state => state.orderReview.orderDetail,
    }),
    returnAdminName () {
      let adminName = null
      try {
        if (this.orderDetail && this.orderDetail.adminprocesslog) {
          const logs = JSON.parse(this.orderDetail.adminprocesslog)
          if (Array.isArray(logs)) {
            for (let i = logs.length - 1; i >= 0; i--) {
              if (logs[i].action === '工单审核不通过') {
                adminName = logs[i].adminname
                break
              }
            }
          }
        }
      } catch (e) {
        console.error('解析 adminprocesslog 失败:', e)
      }
      return adminName
    }
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    showOrderReturnEvalDialog () {
      request.common('getReturnOrderEvalResultApi', {orderid: this.orderDetail.orderid}).then(({data}) => {
        if (data) {
          this.orderReturnEvalForm = {
            is_standard: data.is_standard,
            non_standard_reason: data.non_standard_reason,
            return_adminname: data.return_adminname
          }
          this.reviewer = `${data.adminname} / ${data.adminid}`
          this.reviewAt = data.created_at
          this.isView = true
        } else {
          this.orderReturnEvalForm = {
            is_standard: 1,
            non_standard_reason: [],
            return_adminname: this.returnAdminName
          }
          this.reviewer = `${this.loginUser.name} / ${this.loginUser.id}`
          this.isView = false
        }
      }).finally(() => {
        this.dialogReturnEvalVisible = true
      })
    },
    closeDialog () {
      this.dialogReturnEvalVisible = false
    },
    handleOrderReturnEvalSubmit () {
      this.$confirm('确认提交退单规范评价,请注意仅能评价一次？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          orderid: this.orderDetail.orderid,
          is_standard: this.orderReturnEvalForm.is_standard,
          non_standard_reason: this.orderReturnEvalForm.non_standard_reason,
          return_adminname: this.orderReturnEvalForm.return_adminname
        }
        request.common('evalReturnOrderApi', params).then(() => {
          this.closeDialog()
          this.$message.success('评价提交成功')
        })
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
.form-tip {
  margin-top: 10px;
  margin-left: -10px;
  font-size: 12px;
  line-height: 1.4;
}

.question-labels {
  padding: 4px 8px;
  background: #f5f7fa;
  border-radius: 4px;
  min-height: 32px;
}

.question-label-item {
  padding: 2px 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.7;
  word-break: break-all;

  &:not(:last-child) {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/ReturnOrderStandEvalButton.vue